import { gql } from 'apollo-boost'

const SAVE_MENU_SCRAPING_TASK = gql`
  mutation saveMenuScrapingTask(
    $id: ID!
    $menuData: SaveMenuScrapingTaskMenuInput!
    $menuDocumentFilesData: [MenuScrapingTaskMenuDocumentFileInput!]
  ) {
    saveMenuScrapingTask(
      id: $id
      menuData: $menuData
      menuDocumentFilesData: $menuDocumentFilesData
    ) {
      id
    }
  }
`

export default SAVE_MENU_SCRAPING_TASK
